import React, { Dispatch, SetStateAction, useCallback, useMemo, useRef, useState } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'
import { TopPartnerEditorContent } from 'partner360/features/topPartnersManagement/components/topPartnerEditor/topPartnerEditorContent/TopPartnerEditorContent'
import { IP360PartnerFlags } from 'partner360/models/p360PartnerFlags/IP360PartnerFlags'
import { IPartnerWithFlagRequests } from 'partner360/models/partnerFlagRequests/IPartnerWithFlagRequests'

interface ITopPartnerEditorProps {
  partnerId?: string
  partnerName: string
  bitClass?: number
  topFlags: IP360PartnerFlags[]
  partnerFlags: IP360PartnerFlags[]
  show: boolean
  onClose: () => void
  fYear?: number
  partnersNotInTable: IPartnerWithFlagRequests[]
  allPartners: IPartnerWithFlagRequests[]
  item: IPartnerWithFlagRequests
  setPartners: Dispatch<SetStateAction<IPartnerWithFlagRequests[]>>
  approvers: string[]
}

export const TopPartnerEditor = ({
  show,
  onClose,
  partnerId,
  partnerName,
  topFlags,
  partnerFlags,
  bitClass,
  fYear = 0,
  partnersNotInTable,
  allPartners,
  item,
  setPartners,
  approvers,
}: ITopPartnerEditorProps) => {
  const [isSaving, setIsSaving] = useState(false)
  const savingRef = useRef(false)

  const handleSavingChange = useCallback((saving: boolean) => {
    savingRef.current = saving
    setIsSaving(saving)
  }, [])

  const handleClose = useCallback(() => {
    if (!savingRef.current) {
      onClose()
    }
  }, [onClose])

  const contentProps = useMemo(() => {
    return {
      onClose: handleClose,
      onSavingChange: handleSavingChange,
      isSaving,
      partnerId,
      partnerName,
      topFlags,
      partnerFlags,
      bitClass,
      fYear,
      partnersNotInTable: partnersNotInTable,
      allPartners,
      item,
      setPartners,
      approvers,
    }
  }, [
    approvers,
    bitClass,
    fYear,
    item,
    handleClose,
    handleSavingChange,
    isSaving,
    partnerId,
    partnerName,
    partnersNotInTable,
    allPartners,
    setPartners,
    topFlags,
    partnerFlags,
  ])

  return (
    <ModalDialog
      onClose={handleClose}
      closeOnOutsideClick={!isSaving}
      show={show}
      size={'xs'}
      content={TopPartnerEditorContent}
      contentProps={contentProps}
    />
  )
}
